import { DataAmigavel } from '@/shared/utils/datas';

export function PeriodoLotacaoColaboradorTexto(
  dataInicial?: Date | string | null,
  dataFinal?: Date | string | null,
): string | null {
  const ini = DataAmigavel(dataInicial);
  const fim = DataAmigavel(dataFinal);
  if (!ini && !fim) {
    return null;
  }
  return `(${ini} a ${fim})`;
}
